import compose from 'lodash/flowRight'
import * as React from 'react'
import {connect} from 'react-redux'

import type {State} from '../../../../../reducers/types'
import {getFullPath, getProject} from '../../../../../selectors'
import type {FullPath, ProjectId, ProjectOrBuildTypeNode} from '../../../../../types'
import {emptyArray} from '../../../../../utils/empty'
import BuildPath from '../../../BuildPath/BuildPath'

import styles from './Subproject.css'

type StateProps = {
  path: FullPath
}
type OwnProps = {
  projectId: ProjectId
  level: number
  showFullBreadcrumbs: boolean
}
type Props = StateProps & OwnProps
export const SubprojectBreadcrumbs = compose(
  React.memo,
  connect((state: State, {projectId}: OwnProps) => {
    const nodeType = 'project'
    const parentId = getProject(state, projectId)?.parentProjectId
    const path = parentId
      ? getFullPath(state, {
          nodeType,
          id: parentId,
        })
      : emptyArray
    return {
      path,
    }
  }),
)(function SubprojectBreadcrumbs({projectId, path, showFullBreadcrumbs, level}: Props) {
  const nodeType = 'project'
  const projectNode: ProjectOrBuildTypeNode = React.useMemo(
    () => ({
      nodeType,
      id: projectId,
    }),
    [projectId, nodeType],
  )
  const resultPath = React.useMemo(
    () => (showFullBreadcrumbs ? path : path.slice(path.length - level)),
    [level, path, showFullBreadcrumbs],
  )
  return (
    <div className={styles.parentPath}>
      <BuildPath path={resultPath} projectOrBuildTypeNode={projectNode} />
    </div>
  )
})
